import getGlobalVariable from "../getGlobalVariable";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var throwError = function throwError(message) {
  var _getGlobalVariable;
  var env = (_getGlobalVariable = getGlobalVariable("env")) !== null && _getGlobalVariable !== void 0 ? _getGlobalVariable : "development";
  if (env === "development") {
    throw new Error(message);
  } else {
    // eslint-disable-next-line no-console
    console.error(message);
  }
};
export default throwError;